<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="100px" >
					<!-- 上传图片的组件 -->
					<el-row>
						<!-- <el-form-item label="上传发票" prop="fppic"></el-form-item> -->
						<el-col :span="12" class="userHead" style="margin-left: 80px;">
						<file-upload @change="change" v-model="formParameter.fppic" :rules="rules.fppic"
						uri="/statics/fapiao" model="fileSystem" :size="1024"></file-upload>
						<div style=" font-weight: bold;">
						</div>
						</el-col>
					</el-row>
			</el-form>
		</div>
		<div slot="footer">
			<el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">上次发票</el-button>
			<!-- <el-button @click="confirm1()">审批不合格</el-button> -->
			<el-button @click="close">取 消</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/xueli/fapiao.js';
import fileUpload from '@/components/biz/fileUpload/fileUpload.vue';
export default {
	name: 'edit',
	components: {
			popup,
			fileUpload
		},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},
			fapiaoid:"",
			rules: {
			//上传图片
			fppic: [
				{
					// validator: this.$validate.required,
					required:true,
					message:'不能为空',
					trigger: 'blur'
				}
			]
		}
		};
	},
	methods: {
			// 上传发票
			change(val){
				if(this.formParameter.fppic && this.formParameter.fppic.indexOf('/statics/')>0 ){
				  this.formParameter.fppic = this.formParameter.fppic.substring( this.formParameter.fppic.indexOf('/statics/') ) 
				}
		      
			},
			//打开弹框
			open(row,parameter, title, disabled, size) {
				this.fapiaoid =row;
				this.parameter = parameter;
				this.disabled = disabled;
				this.$refs.popup.open(title, size);
				this.$nextTick(() => {
					this.init();
				})
			},
			//关闭弹框
			close() {
				this.disabled = false;
				this.$refs.popup.close();
			},
			//提交表单
			confirm() {
				this.$utils.checkForm(this.$refs.form, () => 
            	{
				this.confirmLoading = true;	
					//添加
					let parameter = this.$utils.merger(this.formParameter,this.fapiaoid);
					api.upload(parameter,
						response => {
							this.$utils.msg.success(response.msg);
							this.confirmLoading = false;
							this.close();
							this.$parent.list(); 
						},
						response => {
							this.$utils.msg.warning(response.msg);
							this.confirmLoading = false;
						}
                        
					);                
				});
			},
			init() {
				this.popupLoading = true;
				//清除等待
				this.confirmLoading = false;
				//清空内容
				this.formParameter = {};
				//清楚校验
				this.$refs.form.clearValidate();
				
				if (this.parameter.id) {
					//编辑查询数据
					let parameter = {
						id: this.parameter.id
					};
					api.toUpdate(parameter, response => {
						this.formParameter = response.data;
						this.popupLoading = false;
					});
				} else {
					//添加
					this.popupLoading = false;
				}
			}
		}
	};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
	@import '~common/custom/css/popup/popup.scss';
</style>
